import {IAcceptor} from "../../../models/acceptor/IAcceptor";
import {Ic} from "../../../models/common";
import {
  TOPOLOGY_FLYBACK,
  TOPOLOGY_HPF_QR_FLYBACK,
  TOPOLOGY_ISOLATED_FLYBACK,
  TOPOLOGY_NON_ISOLATED_FLYBACK,
  TOPOLOGY_QR_FLYBACK
} from "../../../models/view";
import {Acceptor_Common} from "../../../models/acceptor/acceptor_common";
import {IValidator} from "../../../models/validator/IValidator";
import {isNull} from "util";
import {IComparator} from "../../../models/IComparator";
import {IUpdateDesign, UpdateDesign} from "../../../models/IUpdateDesign";
import {IAppFactoryService} from "../../../Redux/selector.state";
import {Feature} from "../../../models/features/features";
import {Acceptor_AcLed_FlyBack} from "./acceptor/acled_flyback_acceptor";
import {Acceptor_AcLed_QR_FlyBack} from "./acceptor/acled_qr_flyback_acceptor";
import {Comparator_AcDc} from "../../POWER/acdc/comparator";
import {Validator_AcLed_FlyBack} from "./validator/acled_flyback_validator";
import {Validator_AcLed_QR_FlyBack} from "./validator/acled_qr_flyback_validator";
import {Validator_LED_Common} from "../../../models/validator/validator_led_common";

/**
 * Created by claudio iozzia on 28/06/2017.
 */

export class Led_AcDc_Factory {

  private static createAcceptor(a: Ic): IAcceptor {
    // a:Ic cannot be never null

    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_FLYBACK:
      case TOPOLOGY_ISOLATED_FLYBACK:
      case TOPOLOGY_NON_ISOLATED_FLYBACK:
        return new Acceptor_AcLed_FlyBack();
      case TOPOLOGY_QR_FLYBACK:
      case TOPOLOGY_HPF_QR_FLYBACK:
        return new Acceptor_AcLed_QR_FlyBack();
      default:
        return new Acceptor_Common();
    }
  }

  private static createUpdateDesign(a: Ic): IUpdateDesign {
    return new UpdateDesign();
  }

  private static createComparator(): IComparator {
    return new Comparator_AcDc();
  }

  private static createValidator(a: Ic): IValidator {

    if (isNull(a)) {
      return new Validator_LED_Common();
    }

    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_FLYBACK:
      case TOPOLOGY_ISOLATED_FLYBACK:
      case TOPOLOGY_NON_ISOLATED_FLYBACK:
        return new Validator_AcLed_FlyBack();
      case TOPOLOGY_QR_FLYBACK:
      case TOPOLOGY_HPF_QR_FLYBACK:
        return new Validator_AcLed_QR_FlyBack();
      default:
        return new Validator_LED_Common();
    }
  }

  private static createStdFeature(): Feature[] {
    return [];
  }

  public static createService(): IAppFactoryService {
    return {
      acceptorCreator: Led_AcDc_Factory.createAcceptor,
      updateDesignCreator: Led_AcDc_Factory.createUpdateDesign,
      comparator: Led_AcDc_Factory.createComparator(),
      validatorCreator: Led_AcDc_Factory.createValidator,
      stdFeatures: Led_AcDc_Factory.createStdFeature()
    };
  }

}
